package fr.xibalba.generateurClassesLycee.eleves

import fr.xibalba.generateurClassesLycee.Pair
import fr.xibalba.generateurClassesLycee.Triple

//ANGLAIS LV1 pour tous
sealed class Eleve(val nom: String, val prenom: String, val garcon: Boolean) {
    open fun print(): String {
        return "${this.nom} ${this.prenom} (${if (this.garcon) "M" else "F"})"
    }
}
sealed class EleveGeneralEtTechnologique(nom: String, prenom: String, garcon: Boolean, val langue: Langue, val section: Section?) : Eleve(nom, prenom, garcon) {
    override fun print(): String {
        return "${super.print()} - Langue: $langue${section?.let { " - Section: $it" } ?: ""}"
    }
}
class ElevePremiereGenerale(nom: String, prenom: String, garcon: Boolean, langue: Langue, val specialites: Triple<Specialite>, section: Section?) : EleveGeneralEtTechnologique(nom, prenom, garcon, langue, section) {
    override fun print(): String {
        return "Élève de premiere générale: ${super.print()} - Spécialités: $specialites"
    }
}
class EleveTerminaleGenerale(nom: String, prenom: String, garcon: Boolean, langue: Langue, val specialites: Pair<Specialite>, section: Section?, val option: Option?) : EleveGeneralEtTechnologique(nom, prenom, garcon, langue, section) {
    override fun print(): String {
        return "Élève de terminale générale: ${super.print()} - Spécialités: $specialites${option?.let { " - Option: $it" } ?: ""}"
    }
}
class ElevePremiereTechnologique(nom: String, prenom: String, garcon: Boolean, langue: Langue, section: Section?) : EleveGeneralEtTechnologique(nom, prenom, garcon, langue, section) {
    override fun print(): String {
        return "Élève de premiere technologique: ${super.print()}"
    }
}
class EleveTerminaleTechnologique(nom: String, prenom: String, garcon: Boolean, langue: Langue, val typeSTI2D: TypeSTI2D, section: Section?) : EleveGeneralEtTechnologique(nom, prenom, garcon, langue, section) {
    override fun print(): String {
        return "Élève de terminale technologique ($typeSTI2D): ${super.print()}"
    }
}
class EleveTerminalePro(nom: String, prenom: String, garcon: Boolean) : Eleve(nom, prenom, garcon) {
    override fun print(): String {
        return "Élève de terminale professionnelle: ${super.print()}"
    }
}
class EleveBTS(nom: String, prenom: String, garcon: Boolean) : Eleve(nom, prenom, garcon) {
    override fun print(): String {
        return "Élève de BTS: ${super.print()}"
    }
}

fun List<Eleve>.print(): String {
    return joinToString("\n") { it.print() }
}

typealias Classe = List<Eleve>
typealias Classes = List<Classe>